module.exports = __webpack_public_path__ + "static/profile-d5fed33202794a1a56cbf97b763574de.jpg";